import {useMemo} from 'react'
import {useFormContext} from 'react-hook-form'

import type {Point} from '../../../contexts'
import {DeliveryType} from '../types'
import {mapVerticalToDeliveryType} from '../utils/map-vertical-to-delivery-type'

function useNddDestinationPointCoordinates() {
  const {watch} = useFormContext()
  const pickupPointCoordinates: Point = watch('ndd.route.destination_1.pickupPoint.coordinates')

  const addressCoordinatesLongitude = pickupPointCoordinates?.[0]
  const addressCoordinatesLatitude = pickupPointCoordinates?.[1]
  return useMemo(() => {
    const result: number[][] = []

    if (addressCoordinatesLongitude && addressCoordinatesLatitude) {
      result.push([addressCoordinatesLongitude, addressCoordinatesLatitude])
    }

    return result
  }, [addressCoordinatesLatitude, addressCoordinatesLongitude])
}

function useSddExpressDestinationPointsCoordinates() {
  const {watch} = useFormContext()
  const route = watch('route')
  const points = route && Object.keys(route).flatMap(key => key !== 'source' && key !== 'return' && route[key])

  // Points - это массив объектов, поэтому для сравнения используем JSON.stringify
  const hash = JSON.stringify(points)

  return useMemo(() => {
    if (points === undefined) {
      return []
    }

    return points.map(point => point?.address?.coordinates)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hash, points])
}

export function useDestinationPointsCoordinates() {
  const {watch} = useFormContext()
  const sddExpressDestinationPointsCoordinates = useSddExpressDestinationPointsCoordinates()
  const nddDestinationPointCoordinates = useNddDestinationPointCoordinates()

  const deliveryType = mapVerticalToDeliveryType(watch('selected_submode'))

  return useMemo(() => {
    switch (deliveryType) {
      case DeliveryType.Express:
      case DeliveryType.SDD:
        return sddExpressDestinationPointsCoordinates
      case DeliveryType.NDD:
        return nddDestinationPointCoordinates
      default:
        return []
    }
  }, [deliveryType, nddDestinationPointCoordinates, sddExpressDestinationPointsCoordinates])
}
